import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { WalletConnectIcon } from '@dynamic-labs/iconic';

const getDynamicLayoutData = ({ view }) => {
    if (view === 'no-access') {
        const headerData = {
            heading: "You don't have access",
        };
        return { headerData };
    }
    const helpHeaderMap = {
        'login-with-email-or-wallet-full-wallet-list': {
            heading: 'Get your first wallet',
        },
        'pending-connect': {
            heading: 'Connecting a wallet',
        },
        'pending-signature': {
            heading: 'Signing a wallet',
        },
        'pending-signature-without-back-button': {
            heading: 'Signing a wallet',
        },
        'qr-code': {
            heading: 'Connecting a wallet',
        },
        'wallet-connect-mobile-wallets-list': {
            heading: 'Get your first wallet',
        },
        'wallet-list': {
            heading: 'Get your first wallet',
        },
    };
    const headerMap = {
        'account-exists': { heading: 'Account already exists' },
        'chainalysis-blocked-wallet': {
            heading: 'Access denied',
        },
        'login-with-email-or-wallet': { heading: 'Sign in / Sign up' },
        'login-with-email-or-wallet-full-wallet-list': {
            heading: 'Select your wallet',
        },
        'wallet-connect-mobile-wallets-list': {
            heading: (jsxs(Fragment, { children: [jsx(WalletConnectIcon, { style: { height: '1.5rem', width: '1.5rem' } }), ' ', "WalletConnect wallets"] })),
        },
        'wallet-list': { heading: 'Select your wallet' },
        'wallet-sign': { heading: 'Sign to confirm transfer' },
    };
    const helpHeaderData = helpHeaderMap[view];
    const headerData = headerMap[view];
    return {
        headerData,
        helpHeaderData,
    };
};

export { getDynamicLayoutData };
